module.exports = __webpack_public_path__ + "media/images/previous-040c6ed417d5f7209fe676f931cae9b7.png";